import Link from "next/link";
import { downloadLink } from "@/lib/utils.js";
import ResourcesModal from "@/components/resources_modal";
import { useState } from "react";
import ShareSvg from "@/components/svgs/share_svg.js";
import DownloadSvg from "@/components/svgs/download_svg.js";
import ResourceList from "@/components/resource_list";
import BulkAssetLinks from '@/components/bulk_asset_links.js'
export default function ProductResources({
  downloads,
  more_about_text,
  attributes,
  product,
  resource_display,
  config
}) {
  const [show, setShow] = useState(false);

  const downloadContainerId = (category) => {
    let categoryId = category
      .toLowerCase()
      .replace("&", "and")
      .trim()
      .replace(/\s/g, "-");
    return `download-cateogry-${categoryId}`;
  };
  const attributeContainerId = (attributeName) => {
    let attributeId = attributeName
      .toLowerCase()
      .replace("&", "and")
      .trim()
      .replace(/\s/g, "-");
    return `lexcms-attribute-${attributeId}`;
  };
  return (
    <>
      <h3 className="lexcms-product-section-heading">Resources</h3>
      <div className="lexcms-product-resources-content">
        <div className="lexcms-product-downloads-section">
          {Object.keys(downloads || {}).map((resourceCategory, i) => {
            const slicedDownloads =
              resource_display === "modal"
                ? downloads[resourceCategory]?.slice(0, 3)
                : downloads[resourceCategory];
            return (
              <div key={i}>
                <div
                  id={`${downloadContainerId(resourceCategory)}`}
                  className="lexcms-product-download-container"
                >
                  <span>
                    <h4 className="lexcms-product-download-heading">
                      {resourceCategory}
                    </h4>
                    {resource_display === "modal" && (
                      <div>
                        {downloads[resourceCategory]?.length > 3 && (
                          <div
                            className="lexcms-product-download-view-all-section"
                            onClick={() => setShow(resourceCategory)}
                          >
                            <div className="lexcms-product-download-view-all">
                              View All
                            </div>
                            <div className="lexcms-product-download-view-all-count">
                              ({downloads[resourceCategory]?.length})
                            </div>
                            <div className="lexcms-product-download-view-all-icon"></div>
                          </div>
                        )}
                      </div>
                    )}
                  </span>

                  <hr className="lexcms-section-divider"></hr>

                  <ul className="lexcms-product-download-list">
                    {slicedDownloads?.map((d, i) => {
                      return (
                        <li
                          key={i}
                          className="lexcms-product-download-filename"
                        >
                          <Link href={downloadLink(d)}>
                            <a target="_blank">{d.name}</a>
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                {resource_display === "modal"   && (
                  <ResourcesModal
                    show={show === resourceCategory}
                    no_close_on_outside_click={true}
                    setShow={setShow}> <h3>
                      <strong>{product.name}</strong>: {resourceCategory}{" "}
                    </h3>
                    <hr className="lexcms-section-divider"></hr>
                    <ul className="lexcms-product-download-list">
                      {downloads[resourceCategory]?.map((d, i) => {
                        return (
                          <li
                            key={i}
                            className="lexcms-product-download-filename"
                          >
                            <Link href={downloadLink(d)}>
                              <a target="_blank">{d.name}</a>
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </ResourcesModal>
                )}

              </div>
            );
          })}
            <BulkAssetLinks product={product} config={config} />
        </div>
        <div className="lexcms-product-resources-custom-text-and-attributes-section">
          {more_about_text && (
            <div className="lexcms-product-custom-text">
              <div dangerouslySetInnerHTML={{ __html: more_about_text }} />
            </div>
          )}
          <div className="lexcms-product-resources-attributes">
            {Object.keys(attributes || {}).map((attributeName, i) => {
              return (
                <div
                  key={i}
                  className="lexcms-product-attribute-container"
                  id={`${attributeContainerId(attributeName)}`}
                >
                  <h4 className="lexcms-product-attribute-heading">
                    {attributeName}
                  </h4>
                  <ul className="lexcms-product-attribute-list">
                    {attributes[attributeName].map((attr, i) => {
                      return (
                        <li key={i} className="lexcms-product-attribute-value">
                          {attr.display_value}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
